<h2 mat-dialog-title>
  {{ 'AUTOMATIONS.SNIPPET.CREATE_SNIPPET' | translate }}
</h2>

<mat-dialog-content>
  {{ 'AUTOMATIONS.SNIPPET.SNIPPET_SUBTITLE' | translate }}

  <glxy-form-field [required]="true">
    <glxy-label>{{ 'AUTOMATIONS.SNIPPET.SNIPPET_NAME' | translate }}</glxy-label>
    <input [(ngModel)]="snippetName" type="text" matInput />
  </glxy-form-field>

  <glxy-form-field>
    <glxy-label>{{ 'AUTOMATIONS.SNIPPET.SNIPPET_DESCRIPTION' | translate }}</glxy-label>
    <textarea [(ngModel)]="snippetDescription" type="text" matInput maxlength="500"> </textarea>
  </glxy-form-field>
</mat-dialog-content>

<mat-dialog-actions mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>

  <button (click)="saveAsSnippet()" mat-flat-button color="primary">
    <glxy-button-loading-indicator [isLoading]="loading"
      >{{ 'COMMON.ACTION_LABELS.SAVE' | translate }}
    </glxy-button-loading-indicator>
  </button>
</mat-dialog-actions>
